import { ReactElement, useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import trackShowMore from '@helpers/analyticsHelpers/trackShowMoreRelatedProducts';
import Heading from '@atoms/Heading/Heading';
import LoadMore from '@molecules/LoadMore/LoadMore';
import ProductsWithTracking from '@molecules/ProductsWithTracking/ProductsWithTracking';
import Config from '@config';
import { StyledGrid, StyledRelatedProductsBeam, StyledTitleWrapper } from './RelatedProductsBeam.styles';
import { AxfoodPaginationViewModelAxfoodBasicProductViewModel } from '@occ/api-client';

const PAGE_SIZE = 20;

type Props = {
  data: AxfoodPaginationViewModelAxfoodBasicProductViewModel;
  title: string;
  offline?: boolean;
  isPage?: boolean;
};

const RelatedProductsBeam = ({ data, title, offline, isPage }: Props): null | ReactElement => {
  const gridRef = useRef<HTMLDivElement>(null);
  const isMobile = useMediaQuery({
    query: Config.BREAKPOINTS.IS_MOBILE,
  });
  const isTabletPortrait = useMediaQuery({
    query: Config.BREAKPOINTS.IS_TABLET_PORTRAIT,
  });
  const fromTabletLandscape = useMediaQuery({
    query: Config.BREAKPOINTS.FROM_TABLET_LANDSCAPE,
  });

  const getLimit = () => {
    if (isTabletPortrait) {
      return 3;
    }
    if (fromTabletLandscape) {
      return 4;
    }

    return 2;
  };
  const [limit, setLimit] = useState(getLimit());

  useEffect(() => {
    setLimit(getLimit());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile, isTabletPortrait, fromTabletLandscape]);

  const showMore = () => {
    trackShowMore(title);
    setLimit(limit + PAGE_SIZE);
  };

  return data?.items && data?.items?.length > 0 ? (
    <StyledRelatedProductsBeam data-testid="relatedproducts-beam" $isPage={isPage}>
      <StyledTitleWrapper>
        <Heading variant="h2" size="small">
          {title}
        </Heading>
      </StyledTitleWrapper>
      <StyledGrid ref={gridRef}>
        <ProductsWithTracking
          products={[...data.items].splice(0, limit)}
          disableMixMatchButton
          offline={offline}
          category={title}
          gridRef={gridRef}
          isPage={isPage}
        />
      </StyledGrid>
      <LoadMore pageSize={PAGE_SIZE} total={data.items.length} limit={limit} onClick={showMore} showProgress />
    </StyledRelatedProductsBeam>
  ) : null;
};

export default RelatedProductsBeam;
